import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import Home from './views/home/home.vue'
import Demo from './views/home/demo.vue'
import Login from './views/Login.vue'
import SaleAnalysis from './views/saleanalysis/SaleAnalysis.vue'
import FlexMonster from './views/saleanalysis/FlexMonster.vue'
import EquipAnalysis from './views/equipanalysis/EquipAnalysis.vue'
import EquipmentRateAnalysis from './views/equipanalysis/EquipmentRateAnalysis'
import EinbaurateAnalysis from './views/equipanalysis/EinbaurateAnalysis'
import ModelMixClound from './views/modelmixclound.vue';
import EquipGradientAnalysis from './views/equipanalysis/EquipGradientAnalysis.vue'

import Test from './views/test.vue'
import EquipCompare from './views/equipanalysis/EquipCompare.vue'
import EquipModelCompare from './views/equipanalysis/EquipModelCompare.vue'
import EquipPK1 from './views/equipanalysis/EquipPK1.vue'
import EquipPK2 from './views/equipanalysis/EquipPK2.vue'
import EquipPK3 from './views/equipanalysis/EquipPK3.vue'
import EquipPK4 from './views/equipanalysis/EquipPK4.vue'
import PVA from './views/equipanalysis/PVA.vue'
import EquipSale from './views/equipanalysis/EquipSale.vue'
import EquipMSRP from './views/equipanalysis/EquipMSRP.vue'
import InstalledRation from './views/equipanalysis/InstalledRation.vue'
import ModelTimeline from './views/depthanalysis/ModelTimeline.vue'
import PriceLadderAnalysis from './views/depthanalysis/PriceLadderAnalysis.vue'
import LineSaleAnalysis from './views/saleanalysis/LineSaleAnalysis.vue'
import EquipSaleAnalysis from './views/saleanalysis/EquipSaleAnalysis.vue'

import DailyReport from './views/reports/DailyReport.vue'
import MonthlyReport from './views/reports/MonthlyReport.vue'
import DimensionAnalysis from './views/depthanalysis/DimensionAnalysis.vue'
import Espionage from './views/reports/Espionage.vue'
import ChartMgr from './views/manage/ChartMgr.vue'
import SchemaCenter from './views/SchemaCenter.vue'
import Gain from './views/gain.vue'
import GainCharts from './views/gaincharts.vue'
Vue.use(Router)
export default new Router({
    routes: [{
            path: '/',
            redirect: '/login',
        }, {
            path: '/chartmgr',
            name: 'chartmgr',
            component: ChartMgr
        }, {
            path: '/gain',
            name: 'gain',
            component: Gain
        }, {
            path: '/gaincharts',
            name: 'gaincharts',
            component: GainCharts
        },
        {
            path: '/schemacenter',
            name: 'schemacenter',
            component: SchemaCenter
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        }, {
            path: '/index',
            name: 'index',
            component: Index
        },

        {
            path: '/login',
            name: 'login',
            component: Login,
        }, {
            path: '/espionage',
            name: 'espionage',
            component: Espionage,
        },
        {
            path: '/pva',
            name: 'pva',
            component: PVA,
        },
        {
            path: '/dimensionanalysis',
            name: 'dimensionanalysis',
            component: DimensionAnalysis,
        },
        {
            path: '/dailyreport',
            name: 'dailyreport',
            component: DailyReport,
        },
        {
            path: '/monthlyreport',
            name: 'monthlyreport',
            component: MonthlyReport,
        },
        {
            path: '/equipsaleanalysis',
            name: 'equipsaleanalysis',
            component: EquipSaleAnalysis,
        },
        {
            path: '/linesaleanalysis',
            name: 'linesaleanalysis',
            component: LineSaleAnalysis,
        },
        {
            path: '/test',
            name: 'test',
            component: Test,
            children: [{
                    path: '/demo',
                    name: 'demo',
                    component: Demo
                }

            ]
        },
        {
            path: '/saleanalysis',
            name: 'saleanalysis',
            component: SaleAnalysis,
        },
        {
            path: '/flexmonster',
            name: 'flexmonster',
            component: FlexMonster,
        },
        {
            path: '/equipanalysis',
            name: 'equipanalysis',
            component: EquipAnalysis,
        },
        {
            path: '/modelmixclound',
            name: 'modelmixclound',
            component: ModelMixClound,
        },
        {
            path: '/equipmentrateanalysis',
            name: 'equipmentrateanalysis',
            component: EquipmentRateAnalysis,
        }, //equipgadientanalysis
        {
            path: '/einbaurateanalysis',
            name: 'einbaurateanalysis',
            component: EinbaurateAnalysis,
        },
        {
            path: '/equipgradientanalysis',
            name: 'equipgradientanalysis',
            component: EquipGradientAnalysis,
        },
        {
            path: '/priceladderanalysis',
            name: 'priceladderanalysis',
            component: PriceLadderAnalysis,
        },
        {
            path: '/equipcompare',
            name: 'equipcompare',
            component: EquipCompare,
        },
        {
            path: '/equipmodelcompare',
            name: 'equipmodelcompare',
            component: EquipModelCompare,
        },
        {
            path: '/equippk1',
            name: 'equippk1',
            component: EquipPK1,
        },
        {
            path: '/equippk2',
            name: 'equippk2',
            component: EquipPK2,
        },
        {
            path: '/equippk3',
            name: 'equippk3',
            component: EquipPK3,
        },
        {
            path: '/equippk4',
            name: 'equippk4',
            component: EquipPK4,
        },
        {
            path: 'installedration',
            name: 'installedration',
            component: InstalledRation,
        },
        {
            path: '/equipmsrp',
            name: 'equipmsrp',
            component: EquipMSRP,
        },
        {
            path: '/equipsale',
            name: 'equipsale',
            component: EquipSale,
        }, {
            path: '/modeltimeline',
            name: 'modeltimeline',
            component: ModelTimeline
        }
    ]
})